import textHighlight from "./textHighlight"
import parseFaqData from "./parseFaqData"
import fadeAnimation from "./fadeAnimation"
import getAnimatedIcon from "./getAnimatedIcon"
import handleFormFiles from "./handleFormFiles"
import { getCurrentLang } from "./getCurrentLang"

const DASHBOARD_URL = "https://dashboard.webinity.com/"

export {
  DASHBOARD_URL,
  textHighlight,
  parseFaqData,
  fadeAnimation,
  getAnimatedIcon,
  handleFormFiles,
  getCurrentLang,
}
